"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorOptimizeQueryOperationRewriteAdd = void 0;
const bus_optimize_query_operation_1 = require("@comunica/bus-optimize-query-operation");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const utils_algebra_1 = require("@comunica/utils-algebra");
const rdf_data_factory_1 = require("rdf-data-factory");
const DF = new rdf_data_factory_1.DataFactory();
/**
 * A comunica Rewrite Add Optimize Query Operation Actor.
 */
class ActorOptimizeQueryOperationRewriteAdd extends bus_optimize_query_operation_1.ActorOptimizeQueryOperation {
    constructor(args) {
        super(args);
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const factory = new utils_algebra_1.AlgebraFactory(dataFactory);
        const operation = utils_algebra_1.algebraUtils.mapOperation(action.operation, {
            [utils_algebra_1.Algebra.Types.ADD]: {
                preVisitor: () => ({ shortcut: true }),
                transform: (operationOriginal) => {
                    // CONSTRUCT all quads from the source, and INSERT them into the destination
                    const destination = operationOriginal.destination === 'DEFAULT' ?
                        DF.defaultGraph() :
                        operationOriginal.destination;
                    const source = operationOriginal.source === 'DEFAULT' ? DF.defaultGraph() : operationOriginal.source;
                    return factory.createDeleteInsert(undefined, [
                        factory.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o'), destination),
                    ], factory.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o'), source));
                },
            },
        });
        return { operation, context: action.context };
    }
}
exports.ActorOptimizeQueryOperationRewriteAdd = ActorOptimizeQueryOperationRewriteAdd;
//# sourceMappingURL=ActorOptimizeQueryOperationRewriteAdd.js.map